import { useEffect, useState } from "react";
import { useMedals } from "../../hooks/useMedals";
import images from "../../assets/images.js";
import "./index.css";

export const MedalPodium = ({ language, tableWidth }) => {
  const [podiums, setPodiums] = useState([]);
  const { medals } = useMedals();
  const lang = language !== undefined ? language : "en";

  useEffect(() => {
    const unsubscribe = () => {
      const canada = medals.find((medal) => medal.organisation.code === "CAN");
      if (canada) {
        delete canada.medals.total;
        const podiums = Object.keys(canada.medals).map((key) => {
          return {
            count: canada.medals[key],
            colour: key[0].toUpperCase() + key.substring(1),
          };
        });
        const sorted = podiums.sort((a, b) => {
          if (a.count > b.count) {
            return 1;
          }
          if (a.count < b.count) {
            return -1;
          }
          return 0;
        });
        if (
          sorted[0].count === sorted[1].count &&
          sorted[1].count === sorted[2].count
        ) {
          sorted[0].size = 0;
          sorted[1].size = 0;
          sorted[2].size = 0;
        } else if (sorted[0].count === sorted[1].count) {
          sorted[0].size = 1;
          sorted[1].size = 1;
          sorted[2].size = 0;
        } else if (sorted[1].count === sorted[2].count) {
          sorted[0].size = 1;
          sorted[1].size = 0;
          sorted[2].size = 0;
        } else {
          sorted[0].size = 3;
          sorted[1].size = 2;
          sorted[2].size = 1;
        }
        setPodiums([
          sorted.find((podium) => podium.colour === "Silver"),
          sorted.find((podium) => podium.colour === "Gold"),
          sorted.find((podium) => podium.colour === "Bronze"),
        ]);
      }
    };
    unsubscribe();
  }, [medals]);
  

  return (
    <div id="podiumContainer">
      <div className="banner">
        <img
          className="bannerImage OlyBanner"
          src={lang !== "fr" ? images.get("OLY1") : images.get("OLY2")}
          alt="Paris 2024"
        />
      </div>
      <div className="podiumHeader">
        <img src={images.get("CAN")} alt="CAN Flag" />
        {lang !== "fr" ? <h1>Canada Medals</h1> : <h1>Médailles du Canada</h1>}
      </div>
      <div className="Podiums">
        {podiums.map((podium, i) => {
          let src;
          switch (podium.colour.toLowerCase()) {
            case "silver":
              src = images.get("silver");
              break;
            case "gold":
              src = images.get("gold");
              break;
            case "bronze":
              src = images.get("bronze");
              break;
            default:
              src = "";
          }

          return (
            <div className="podiumRow">
              <img src={src} alt={podium.colour} className="medalPodium" />
              <div key={i} className={`podium ${podium.colour.toLowerCase()}`}>
                <span className="count">{podium.count}</span>
              </div>
            </div>
          );
        })}
      </div>
      <img
        className="footerImage"
        src={lang !== "fr" ? images.get("CP1") : images.get("CP2")}
        alt={lang !== "fr" ? "The Canadian Press" : "La Presse Canadienne"}
      />
    </div>
  );
};
